'use client';

import React, {FC} from 'react';
import Image from 'next/image';

import styles from './styles.module.scss';

const Data: FC = () => {
  return (
    <section className="section-data">
      <div className="default-container">
        <div className={styles['data']}>
          <div data-testid="data-section" className={styles['data__item']}>
            <picture>
              <source
                srcSet="/static/img/homepage/nerdwallet-2024.svg"
                type="image/svg"
              />
              <Image
                src="/static/img/homepage/nerdwallet-2024.svg"
                alt="Nerdwallet award"
                width="125"
                height={57}
                unoptimized
              />
            </picture>
          </div>
          <div data-testid="data-section" className={styles['data__item']}>
            <picture>
              <source
                srcSet="/static/img/homepage/forbes-2024.svg"
                type="image/svg"
              />
              <Image
                src="/static/img/homepage/forbes-2024.svg"
                alt="Forbes logo"
                width="95"
                height={26}
                unoptimized
              />
            </picture>
          </div>
          <div data-testid="data-section" className={styles['data__item']}>
            <picture>
              <source
                srcSet="/static/img/homepage/webp/fast-company-2024.svg"
                type="image/svg"
              />
              <Image
                src="/static/img/homepage/fast-company-2024.svg"
                alt="Most Innovative Company"
                width="89"
                height={40}
                unoptimized
              />
            </picture>
          </div>
          <div data-testid="data-section" className={styles['data__item']}>
            <source srcSet="/static/svg/homepage/cnbc+.svg" type="image/svg" />
            <Image
              src="/static/img/homepage/cnbc+.svg"
              alt="CNBC logo"
              width="57"
              height={37}
              unoptimized
            />
          </div>
        </div>

        <div className={styles['data-disclosures']}>
          * Best Online Financial Advisor is a rating given by NerdWallet for
          the calendar years ’22, ’23, & ’24 based on several criteria to
          compare companies that provide financial planning services online or
          connect users with a financial advisor. Zoe Financial did not
          compensate NerdWallet for the rating, however Zoe does have a referral
          agreement with NerdWallet which creates a conflict of interest. Most
          Innovative Companies is a rating given by Fast Company for the
          calendar year ’22, recognizing the organizations that are transforming
          industries and shaping society. Find more information on FastCompany
          Awards, Nerdwallet Awards, and additional disclosures here. + The
          preceding endorsements were provided by non-clients of Zoe Financial.
          No compensation was provided for these endorsements. These
          endorsements do not guarantee a level of success, nor do they
          guarantee that all users will have the same experience.
        </div>
      </div>
    </section>
  );
};

export default Data;
